import { getEnvVar } from 'util/env';

export type APIVersion = 'v1' | 'v2';

const API_HOST = getEnvVar('API_BASE_URL');

export function getAPIUrl({
  path,
  prefix,
  version,
  isAdmin = true,
}: {
  path: string;
  prefix?: string;
  version: APIVersion;
  isAdmin?: boolean;
}) {
  return `${API_HOST}/api/${prefix || ''}${version === 'v1' && isAdmin ? `${version}/admin` : version}${path}`;
}
